module.exports = __webpack_public_path__ + "img/remove_background2.92cfb219.png";